import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const getReportStart = () => {
    return {
        type: actionTypes.GET_REPORT_START
    }
}

export const getReportSuccess = (data) => {
    return {
        type: actionTypes.GET_REPORT_SUCCESS,
        report: data
    }
}

export const getReportFail = (err) => {
    return {
        type: actionTypes.GET_REPORT_FAIL,
        error: err
    }
}



export const getReport = (agentId, startDate, endDate, token) => {
    return async dispatch => {
        dispatch(getReportStart());
        let url = `${api}/transactions/report/${agentId}/${startDate}/${endDate}`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {}
        };
        await axios(options)
            .then(response => {
                dispatch(getReportSuccess(response.data));
            })
            .catch(err => {
                dispatch(getReportFail('get report failed ' + err));
            });
    }
}

export const sendSmsStart = () => {
    return {
        type: actionTypes.SEND_SMS_START,
    }
}

export const sendSmsSuccess = () => {
    return {
        type: actionTypes.SEND_SMS_SUCCESS,
    }
}

export const sendSmsFail = (err) => {
    return {
        type: actionTypes.SEND_SMS_FAIL,
        error: err
    }
}

export const sendSms = (report, token) => {
    return async dispatch => {
        dispatch(sendSmsStart());
        let url = `${api}/transactions/sendSms`;
        const options = {
            url: url,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: report
        };
        await axios(options)
            .then(response => {
                dispatch(sendSmsSuccess());
            })
            .catch(err => {
                dispatch(sendSmsFail('send sms failed ' + err));
            });
    }
}

export const getStatementStart = () => {
    return {
        type: actionTypes.GET_STATEMENT_START
    }
}

export const getStatementSuccess = (data) => {
    return {
        type: actionTypes.GET_STATEMENT_SUCCESS,
        statement: data
    }
}

export const getStatementFail = (err) => {
    return {
        type: actionTypes.GET_STATEMENT_FAIL,
        error: err
    }
}

export const getStatement = (agentId, startDate, endDate, token) => {
    return async dispatch => {
        dispatch(getStatementStart());
        let url = `${api}/transactions/reports/${agentId}/${startDate}/${endDate}`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {}
        };
        await axios(options)
            .then(response => {
                dispatch(getStatementSuccess(response.data));
            })
            .catch(err => {
                dispatch(getStatementFail('get statement failed ' + err));
            });
    }
}

export const getReportDetailStart = () => {
    return {
        type: actionTypes.GET_REPORT_DETAIL_START
    }
}

export const getReportDetailSuccess = (data) => {
    return {
        type: actionTypes.GET_REPORT_DETAIL_SUCCESS,
        reportDetail: data
    }
}

export const getReportDetailFail = (err) => {
    return {
        type: actionTypes.GET_REPORT_DETAIL_FAIL,
        error: err
    }
}

export const getReportDetail = (reportId, token) => {
    return async dispatch => {
        dispatch(getReportDetailStart());
        let url = `${api}/transactions/reports/${reportId}`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {}
        };
        await axios(options)
            .then(response => {
                dispatch(getReportDetailSuccess(response.data));
            })
            .catch(err => {
                dispatch(getReportDetailFail('get statement failed ' + err));
            });
    }
}